import { useEffect, useMemo, useState } from "react";
import {
  Modal,
  Button,
  Label,
  TextInput,
  Select,
  Textarea,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "flowbite-react";

export default function RegionFormModal({
  open,
  onClose,
  initialData,
  onSubmit,
  saving,
  states = [],
}) {
  const isEdit = !!initialData?.id;

  const defaults = useMemo(
    () => ({
      state_id: "",
      name: "",
      notes: "",
    }),
    [],
  );

  const [form, setForm] = useState(defaults);
  const [touched, setTouched] = useState({});

  useEffect(() => {
    if (!open) return;

    if (!initialData) {
      setForm(defaults);
      setTouched({});
      return;
    }

    setForm({
      state_id: initialData.state_id ?? "",
      name: initialData.name ?? "",
      notes: initialData.notes ?? "",
    });
    setTouched({});
  }, [open, initialData, defaults]);

  const errors = {
    state_id: !form.state_id ? "Obrigatório" : null,
    name: !form.name?.trim() ? "Obrigatório" : null,
  };

  const hasErrors = !!(errors.state_id || errors.name);

  function setField(key, value) {
    setForm((s) => ({ ...s, [key]: value }));
  }

  function markTouched(key) {
    setTouched((t) => ({ ...t, [key]: true }));
  }

  function handleSave() {
    setTouched({ state_id: true, name: true });
    if (hasErrors) return;

    const payload = {
      state_id: form.state_id,
      name: form.name.trim(),
      notes: form.notes?.trim() ? form.notes.trim() : null,
    };

    onSubmit(payload);
  }

  return (
    <Modal show={open} onClose={onClose}>
      <ModalHeader>{isEdit ? "Editar Region" : "Nova Region"}</ModalHeader>

      <ModalBody>
        <div className="space-y-4">
          <div>
            <Label htmlFor="state_id" value="State" />
            <Select
              id="state_id"
              value={form.state_id}
              onChange={(e) => setField("state_id", e.target.value)}
              onBlur={() => markTouched("state_id")}
              disabled={saving === true}
            >
              <option value="">Selecione...</option>
              {states.map((st) => (
                <option key={st.id} value={st.id}>
                  {st.code} - {st.name}
                </option>
              ))}
            </Select>

            {touched.state_id && errors.state_id ? (
              <p className="mt-1 text-sm text-red-600">{errors.state_id}</p>
            ) : null}
          </div>

          <div>
            <Label htmlFor="name" value="Name" />
            <TextInput
              id="name"
              value={form.name}
              onChange={(e) => setField("name", e.target.value)}
              onBlur={() => markTouched("name")}
              placeholder="Central District"
              color={touched.name && errors.name ? "failure" : "gray"}
              helperText={touched.name && errors.name ? errors.name : null}
              disabled={saving === true}
            />
          </div>

          <div>
            <Label htmlFor="notes" value="Notes" />
            <Textarea
              id="notes"
              rows={4}
              value={form.notes}
              onChange={(e) => setField("notes", e.target.value)}
              placeholder="Observações do distrito..."
              disabled={saving === true}
            />
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          className="text-slate-600"
          onClick={handleSave}
          disabled={saving === true}
        >
          {saving === true ? "Salvando..." : "Salvar"}
        </Button>
        <Button color="gray" onClick={onClose} disabled={saving === true}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
}
